// import utility functions
import {
  calculateNumeratorDenominatorPayment,
  calculatePrincipalRateTerm,
  deformatCurrency,
  formatCurrencyString,
} from '../util';

/**
 *
 * Calculate income required to qualify for an entered loan amount
 * Formula for this was adapated from the old PHP calculators OTHL sites used to use
 *
 * Parameters are all values from inputs
 *
 * @param {string} totalHomeLoanAmount
 * @param {string} annualInterestRate
 * @param {string} termOfTheLoan
 * @param {string} annualRealEstateTaxes
 * @param {string} monthlyDebtObligations
 * @return {string} calculated annual income required
 */
function calculateIncomeRequired(
  totalHomeLoanAmount,
  annualInterestRate,
  termOfTheLoan,
  annualRealEstateTaxes,
  monthlyDebtObligations
) {
  // if empty string sent do this, otherwise deformatCurrency will geek
  if (!annualRealEstateTaxes) annualRealEstateTaxes = '$0';
  if (!monthlyDebtObligations) monthlyDebtObligations = '$0';

  const [principal, rate, term] = calculatePrincipalRateTerm({
    totalHomeLoanAmount,
    annualInterestRate,
    termOfTheLoan,
  });

  // numerator and denominator not used here
  const [, , payment] = calculateNumeratorDenominatorPayment({
    rate,
    term,
    principal,
  });

  const annualPayment = payment * 12;
  const annualTax = parseInt(deformatCurrency(annualRealEstateTaxes));
  const annualDebt = deformatCurrency(monthlyDebtObligations) * 12;

  const income = formatCurrencyString(
    (annualPayment + annualDebt + annualTax) / 0.44
  );

  return income;
}

export default calculateIncomeRequired;



// WEBPACK FOOTER //
// ./scripts/svelte/calculators/incomeRequiredCalculator/calculateIncomeRequired.js